export default __webpack_public_path__ + "static/media/Asset 4@10x-8.abc12a32.png";